import { safeString } from "../../helpers";
import { parseSettlementStatus, getIsCashOutOrCancelled } from "../parseSettlementStatus";
import { getBonusOdds } from "./getBonusOdds";
export function parseOdds(bet, playerBonus) {
    const settlementStatus = parseSettlementStatus(bet.settlementStatus);
    const isCashOutOrCancelled = getIsCashOutOrCancelled(settlementStatus);
    if (bet.earlyExitStatus !== "Full") {
        if (isCashOutOrCancelled) {
            return {
                originalDisplayOdds: safeString(bet.displayOdds),
                newOdds: undefined,
                newOddsVariant: undefined
            };
        }
        return getBonusOdds(bet, playerBonus);
    }
    else {
        return {
            originalDisplayOdds: safeString(bet.displayOdds),
            newOdds: undefined,
            newOddsVariant: undefined
        };
    }
}
//# sourceMappingURL=parseOdds.js.map